// Angular Files
import { Component, inject } from '@angular/core';

// Angular Material Files
import { MatSidenav } from '@angular/material/sidenav';

// Teller Online Files
import { AuthService, UserService } from 'apps/public-portal/src/app/core/services';
import {
    PaymentProcessorProvider
} from 'apps/public-portal/src/app/payment-integrations/base/service/payment-processor.provider';

// Teller Online Library Files
import { TerminologyNameEnumDto } from 'libraries/core/src/lib/api/CoreWebApi';
import {
    TellerOnlineAppService,
    TellerOnlineSiteMetadataService
} from 'teller-online-libraries/core';

@Component({
    selector: 'app-account-menu',
    templateUrl: 'account-menu.component.html',
    styleUrls: ['./account-menu.component.scss'],
    host: {
        class: 'account-menu'
    },
    standalone: false
})
export class AccountMenuComponent {
    private sidenav = inject(MatSidenav);

    public readonly linkedAccountTermName = TerminologyNameEnumDto.LinkedAccount;

    constructor(
        public appService: TellerOnlineAppService,
        public siteMetadataService: TellerOnlineSiteMetadataService,
        public userService: UserService,
        public authService: AuthService,
        public paymentProvider: PaymentProcessorProvider
    ) { }

    /** Initials for the avatar monogram (first + last word of the user's name). */
    get userInitials(): string {
        const name = (this.userService.currentUser?.name || 'User').trim();
        const parts = name.split(/\s+/);
        const first = parts[0].charAt(0);
        const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';

        return (first + last).toUpperCase();
    }

    get canSavePaymentMethod(): boolean {
        return this.paymentProvider?.canSavePaymentMethod || false;
    }

    get scheduledPaymentsEnabled(): boolean {
        return this.siteMetadataService?.scheduledPaymentsEnabled || false;
    }

    get linkedAccountsEnabled(): boolean {
        return this.siteMetadataService?.linkedAccountsEnabled || false;
    }

    public close() {
        this.sidenav.close();
    }

    onClick_signOut = async () => {
        await this.authService.signOut('/sign-in');
    };
}
